import { useContext } from "react";
/* import TypeIt from "typeit-react"; */
import { LocaleContext } from '../context/LocaleContext';

export default function Footer({ loaded }){
    const { language } = useContext(LocaleContext)

    return (
        <footer className={`row ${ !loaded && 'd-none' }`}>
            <div className="col-12 col-md-8 offset-md-2 pt-3 px-5">
                <p className="lead text-center" style={{ fontSize: 'smaller' }}>
                    {console.log(language)}
                    {
                        language === 'ita' ?
                            'Autorizzo il trattamento dei miei dati personali presenti nel cv ai sensi dell’art. 13 del Decreto Legislativo 30 giugno 2003, n. 196 “Codice in materia di protezione dei dati personali” e dell’art. 13 del GDPR (Regolamento UE 2016/679)'
                        :
                            'In compliance with the GDPR and Italian Legislative Decree no. 196 dated 30/06/2003, I hereby authorize the recipient of this document to use and process my personal details for the purpose of recruiting and selecting staff and I confirm to be informed of my rights in accordance to art. 7 of the above mentioned Decree.'
                    }
                </p>
            </div>
        </footer>
    )
}